import ServiceGraphQL from 'src/service/gql-service';
import { createIndividual } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateIndividual = (data) => {
  const params = {
    query: createIndividual.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.individualCreateOne;
    })
    .catch((err) => {
      throw err;
    });
};
